var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFiberDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_4680)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1180_4680",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 0C28.6569 0 30 1.34315 30 3V27C30 28.6569 28.6569 30 27 30H21V25H9V30H3C1.34315 30 0 28.6569 0 27V3C3.86553e-07 1.34315 1.34315 0 3 0H27Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27 0C28.6569 0 30 1.34315 30 3V27C30 28.6569 28.6569 30 27 30H21V25H9V30H3C1.34315 30 0 28.6569 0 27V3C3.86553e-07 1.34315 1.34315 0 3 0H27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 30H19V32H21V30ZM21 25H23V23H21V25ZM9 25V23H7V25H9ZM9 30V32H11V30H9ZM3 30L3 32H3V30ZM0 3L-2 3V3H0ZM27 0V2C27.5523 2 28 2.44772 28 3H30H32C32 0.238576 29.7614 -2 27 -2V0ZM30 3H28V27H30H32V3H30ZM30 27H28C28 27.5523 27.5523 28 27 28V30V32C29.7614 32 32 29.7614 32 27H30ZM27 30V28H21V30V32H27V30ZM21 30H23V25H21H19V30H21ZM21 25V23H9V25V27H21V25ZM9 25H7V30H9H11V25H9ZM9 30V28H3V30V32H9V30ZM3 30L3 28C2.44772 28 2 27.5523 2 27H0H-2C-2 29.7614 0.238577 32 3 32L3 30ZM0 27H2V3H0H-2V27H0ZM0 3L2 3C2 2.44772 2.44772 2 3 2V0V-2C0.238576 -2 -2 0.238577 -2 3L0 3ZM3 0V2H27V0V-2H3V0Z",
    fill: "#AAAAAA",
    mask: "url(#path-2-inside-1_1180_4680)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_4680"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H27C28.6569 0 30 1.34315 30 3V27C30 28.6569 28.6569 30 27 30H3C1.34315 30 0 28.6569 0 27V3Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFiberDisabled);
export default __webpack_public_path__ + "static/media/icn_fiber_disabled.6d9c214c36f77100829229b206861017.svg";
export { ForwardRef as ReactComponent };